const getUserLS = () => JSON.parse(localStorage.getItem('user'));

const getGenderName = (gender) => {
  return gender.toLowerCase() == 'f' ? 'Female' : gender.toLowerCase() == 'm' ? 'Male' : '-';
};

const getRegexEmail = () => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
};

const hideEmail = function (email) {
  return email.replace(/(.{2})(.*)(?=@)/, function (gp1, gp2, gp3) {
    for (let i = 0; i < gp3.length; i++) {
      gp2 += '*';
    }
    return gp2;
  });
};

const hideMobile = function (mobile) {
  return mobile.slice(0, 3) + mobile.slice(3).replace(/.(?=....)/g, '*');
};

const displayPrice = (price, fixed = 2) => {
  return parseFloat(Math.round(Number(price) * 100) / 100).toFixed(fixed);
};

const getTomorrow = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  return (
    tomorrow.getFullYear() +
    '-' +
    ('0' + (tomorrow.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + tomorrow.getDate()).slice(-2)
  );
};

const stringifyArrays = (arrays) => {
  const stringifiedArrays = {};
  for (const key in arrays) {
    if (Object.prototype.hasOwnProperty.call(arrays, key)) {
      stringifiedArrays[key] = JSON.stringify(arrays[key]);
    }
  }
  return stringifiedArrays;
};

const comparePriceArrays = (arr1, arr2) => {
  // Handle edge cases
  if (!arr1 || !arr2) return arr1 === arr2;
  if (arr1.length !== arr2.length) return false;
  if (arr1.length === 0) return true;

  // Compare element by element
  for (let i = 0; i < arr1.length; i++) {
    const price1 = Number(arr1[i].price).toFixed(2);
    const price2 = Number(arr2[i].price).toFixed(2);
    const tax1 = Number(arr1[i].tax_rate).toFixed(2);
    const tax2 = Number(arr2[i].tax_rate).toFixed(2);

    if (price1 !== price2 || tax1 !== tax2) {
      return false;
    }
  }

  return true;
};

export {
  comparePriceArrays,
  displayPrice,
  getGenderName,
  getRegexEmail,
  getTomorrow,
  getUserLS,
  hideEmail,
  hideMobile,
  stringifyArrays
};
